import { AppointmentDTO } from '@/models/AppointmentDTO';
import { Component, Vue } from 'vue-property-decorator';
import { GetterTypes } from '@/store-vuex/types';
import InputText from '../inputs/InputText/InputText';
import InputDate from '../inputs/InputDate/InputDate';
import LocalityAutoComplete from '../LocalityAutoComplete/LocalityAutoComplete';
import InputTime from '../inputs/InputTime/InputTime';
import { LocalityDTO } from '@/models/LocalityDTO';
import LocalityService from '@/services/locality.service';
import moment from 'moment';
import { McsisConstants } from '@/models/constants/McsisConstants';

@Component({
    components: {
        InputText,
        InputDate,
        InputTime,
        LocalityAutoComplete,
    },
})
export default class Appointment extends Vue {
    public locality: LocalityDTO = {} as LocalityDTO;

    /**
     * Get the AppointmentDTO instance
     */
    public get appointment(): AppointmentDTO {
        return this.$store.getters[GetterTypes.appointment];
    }

    protected async mounted() {
        const center = this.appointment.center;
        if (center) {
            const locId = center.ecAddress.locality.locId as number;
            this.locality = await LocalityService.fetchLocality(locId);
        }
    }
}
